export interface Availability {
    days: Array<any>;
    nextAvailable: string;
    hasFutureSlots?: boolean;
}

export interface Coords {
    latitude: number;
    longitude: number
}

export interface IProvider {
    npi: string;
    firstName: string;
    lastName: string;
    academicTitle: string;
    clinic: string;
    clinicOldName: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    phone: string;
    gender: string;
    language: string;
    languageList: string[];
    clinicalInterests: string;
    otherServices: string;
    ageCutoff?: number;
    title: string;
    availability: Availability;
    certification: string;
    education: string;
    affiliation: string;
    insurance: string;
    insuranceList: string[];
    location: Coords;
    photo: string;
    departmentId: string;
    virtualVisit?: boolean;
    virtualist?: boolean;   
}

export interface Appointment {
    npi: string;
    firstName: string;
    lastName: string;
    academicTitle: string;
    startTime: Date;
    clinic: string;
    photo: string;
    address1?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    phone?: string;
    apptType?: string;
    formOptions?: PersonalInfoFormOptions;
    ageCutoff?: number;
    virtualist?: boolean;
}

interface FormOption {
    name: string;
    value: string;
}

interface PersonalInfoFormOptions {
    preferredLanguage: Array<FormOption>;
    legalSex: Array<FormOption>;
    genderIdentity: Array<FormOption>;
    state: Array<FormOption>;
}

export class BookingInfo {
    firstName: string = "";
    lastName: string = "";
    dateOfBirth: string = "";
    preferredLanguage: string = "";
    otherLanguage: string = "";
    legalSex: string = "";
    gender: string = "";
    address1: string = "";
    address2: string = "";
    city: string = "";
    state: string = "";
    zip: string = "";
    cellPhone: string = "";
    cellPhoneOptIn: boolean = false;
    cellPhoneVerified: boolean = false;
    homePhone: string = "";
    email: string = "";
    emailOptIn: boolean = false;
    emailVerified: boolean = false;
    npi: string = "";
    startTime: string = "";
    departmentId: string = "";
    apptType: string = "";
    visitReason: string = "";
}

export interface IPersonalInfo {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    preferredLanguage: string;
    otherLanguage: string;
    legalSex: string;
    gender: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    cellPhone: string;
    cellPhoneOptIn: boolean;
    cellPhoneVerified: boolean;
    homePhone: string;
    email: string;
    emailOptIn: boolean;
    emailVerified: boolean;
    npi: string;
    startTime: string;
    visitReason?: string;
    visitReasonText?: string;
    departmentId: string;
    apptType: string
}

export interface IInsuranceInfo {
    carrierName: string;
    memberId: string;
    groupNumber: string;
    subscriberName: string;
    subscriberId: string;
    subscriberDob: string;
    relationshipToSubscriber: string;
}